import { render, staticRenderFns } from "./PostcodeLookupField.vue?vue&type=template&id=08c621a8&scoped=true&"
import script from "./PostcodeLookupField.vue?vue&type=script&lang=js&"
export * from "./PostcodeLookupField.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeLookupField.vue?vue&type=style&index=0&id=08c621a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c621a8",
  null
  
)

export default component.exports